import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';

import { injectCatchHttpError } from '../../../core/errors/catch-http-error.util';
import type { IPasswordRecoveryActionPayload } from '../../models';
import { ApiAuthService } from '../../services/api-auth.service';
import { sendForm, sendFormFail, sendFormSuccess } from './recovery-password.actions';

@Injectable()
export class RecoveryPasswordEffects {
  private apiAuthService = inject(ApiAuthService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  recoverPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendForm),
      map(action => action.recoverPasswordData),
      exhaustMap((recoverPasswordData: IPasswordRecoveryActionPayload) =>
        this.apiAuthService.recoverPassword(recoverPasswordData).pipe(
          map(() => sendFormSuccess()),
          this.catchHttpError(error => sendFormFail({ error })),
        ),
      ),
    ),
  );
}
